import {
  MOCK_CATALOG,
  MOCK_HEADLINES,
  MOCK_OVERVIEW,
  MOCK_SEARCH,
  MOCK_TEMPLATES,
  MOCK_USERS,
} from './mockData';

import type { CustomMetricsApi } from '../CustomMetricsApi';
import type { CustomMetricsQueryParams } from '../types';

/**
 * In-browser metrics client for local UX and tests. Ignores query params but accepts them
 * so call sites match the real client.
 */
export class CustomMetricsMockClient implements CustomMetricsApi {
  async getCatalog(_params: CustomMetricsQueryParams) {
    return {
      mostVisited: MOCK_CATALOG.mostVisited.map(r => ({ ...r })),
      visitsTrend: [...MOCK_CATALOG.visitsTrend],
    };
  }

  async getHeadlines(_params: CustomMetricsQueryParams) {
    const h = MOCK_HEADLINES;
    return {
      users: {
        ...h.users,
        trend: [...h.users.trend],
      },
      templates: {
        ...h.templates,
        runsTrend: [...h.templates.runsTrend],
      },
      search: {
        ...h.search,
        searchesTrend: [...h.search.searchesTrend],
      },
    };
  }

  async getOverview(_params: CustomMetricsQueryParams) {
    return { ...MOCK_OVERVIEW, trend: [...MOCK_OVERVIEW.trend] };
  }

  async getSearch(_params: CustomMetricsQueryParams) {
    return {
      ...MOCK_SEARCH,
      searchesTrend: [...MOCK_SEARCH.searchesTrend],
    };
  }

  async getTemplates(_params: CustomMetricsQueryParams) {
    return {
      ...MOCK_TEMPLATES,
      topTemplates: MOCK_TEMPLATES.topTemplates.map(r => ({ ...r })),
      runsTrend: [...MOCK_TEMPLATES.runsTrend],
    };
  }

  async getUsers(_params: CustomMetricsQueryParams) {
    return {
      ...MOCK_USERS,
      trend: [...MOCK_USERS.trend],
    };
  }
}
